import { useSearchStore } from '../stores/searchStore'

const CONTENT_TYPES = [
  { value: 'all', label: 'All' },
  { value: 'exchange', label: 'Exchanges' },
  { value: 'youtube', label: 'YouTube' },
  { value: 'blog', label: 'Blog' },
  { value: 'pdf', label: 'PDF' },
  { value: 'notecard', label: 'Notes' },
]

export default function FilterChips() {
  const { typeFilter, setTypeFilter } = useSearchStore()

  return (
    <div className="flex gap-2 overflow-x-auto pb-1 scrollbar-hide">
      {CONTENT_TYPES.map((type) => (
        <button
          key={type.value}
          onClick={() => setTypeFilter(type.value)}
          className={`shrink-0 px-3 py-1 rounded-full text-xs font-medium transition-colors ${
            typeFilter === type.value
              ? 'bg-accent text-bg'
              : 'bg-surface text-text-secondary border border-border'
          }`}
        >
          {type.label}
        </button>
      ))}
    </div>
  )
}
